import {useQuery} from "react-query";
import ContainersPerMonthApi from "./ContainersPerMonth.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useContainersPerMonth(query:IWidgetQuery){
    return useQuery(["fetchContainersPerMonth", query], ContainersPerMonthApi.getData);
}